import { clsx } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * cn (className) 유틸리티 함수
 *
 * Tailwind CSS 클래스를 조건부로 결합하고 충돌을 해결합니다.
 *
 * 사용 예시:
 * cn("px-4 py-2", isActive && "bg-primary", className)
 * cn("text-sm", { "font-bold": isBold, "text-red-500": hasError })
 */
export function cn(...inputs) {
  return twMerge(clsx(inputs));
}
